;(function($, window, document){
    window.RegisterForm = Me.view.extend({
        options: {
        },

        initialize: function() {
            _.bindAll(this, 'submitForm');

            this.addEvents();

        },
        addEvents: function() {
            console.log(this.$('input[type="submit"]'));
            this.$('input[type="submit"]').on('click', this.submitForm);
        },
        submitForm: function(e) {
            var view = this;
            e.preventDefault();

            grecaptcha.ready(function() {
                grecaptcha.execute(recaptchaKey, {action: 'contact_us'}).then(function(token) {
                    // Add your logic to submit to your backend server here.
                    view.$el.find('.g-recaptcha-response').val(token);
                    document.getElementById("register-form").submit();
                });
            });
        }

    });
}(jQuery, window, document));
